export const environment = {
  apiUrl: "https://consoleadmin.acetech.com/api",
  idProvider: "https://auth.acetech.com/auth/realms/ACETECH",
  keycloakClientId: "SSOAdmin",
  production: true,
  defaultCustomerName: "Acetech",
  defaultCustomerKey: "acetech",
  clickPreventionTimer: 10,
};
